import { useState, useEffect } from 'react';

export function useElementSize(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    // Create a ResizeObserver instance
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });

    // Start observing
    observer.observe(ref.current);

    // Cleanup on unmount or ref change
    return () => observer.disconnect();
  }, [ref]);

  return size;
}
